 

import { Profile } from "../models/Profile";
import { HeightUnit } from "../models/HeightUnit";
import { LengthUnit } from "../models/LengthUnit";
import { WeightUnit } from "../models/WeightUnit";
import { ProfileActions } from "./profile/actions";
import { WeightActions } from "./weight/actions";
import { HealthInputName } from "../ui/health/types";

export const initialState: Profile = {
    id: "",
    user_id: "",
    firstName: "",
    preferred_name: "",
    lastName: "",
    city: "",
    mailaddress1: "",
    mailaddress2: "",
    state: "",
    zip_code: "",
    diabetic: "",
    activity: "",
    bp_diastolic: 0,
    bp_systolic: 0,
    gender: "",
    hba1c: 0,
    height: "0",
    height_unit: HeightUnit.FEET,
    hip: 0,
    hip_unit: LengthUnit.IN,
    postgluco: 0,
    pregluco: 0,
    waist: 0,
    waist_unit: LengthUnit.IN,
    weight: 0,
    weight_unit: WeightUnit.POUND,
    weightLossFactor: 0,
    cellPhone: "",
    withings_connected: false,
    email: "",
    calorie_budget: 0,
    protein_budget: 0,
    carbs_budget: 0,
    birthYear: undefined,
    fat_budget: 0,
    timezone: "",
    confirmed: false,
    address_confirmed: false,
    firstTimeUser: false,
    goal_weight: "",
    initial_weight: 0,
    avatar_url: "",
    date_of_birth: "",
    full_name: "",
    tz_timezone: "",
    participant: false,
    max_upload_size: 10 * 1024 * 1024,
    updated_at: "",
    coach_name: "",
    widgetOrder: [
        HealthInputName.Weight,
        HealthInputName.Exercise,
        HealthInputName.BloodPressure,
        HealthInputName.TobaccoCount,
        HealthInputName.BloodSugar,
        HealthInputName.Hba1c,
    ],
    sodium_budget: 0,
    goal_blood_sugar: 0,
    goal_tobacco_count: 0,
    goal_diastolic: 0,
    goal_systolic: 0,
    goal_exercise: 0,
    goal_blood_sugar_low: 0,
    goal_blood_sugar_high: 0,
    display_name: "",
    dppStartDate: "",
    joinDate: "",
};

export function profile(
    state = initialState,
    action: ProfileActions | WeightActions,
): Profile {
    switch (action.type) {
        case "profile/fetch-success":
            return action.data;

        case "profile/update-success":
            return action.data;

        case "weight/save-success":
            if (action.is_today) {
                return { ...state, weight: Number(action.weight) };
            }
            return state;
        default:
            return state;
    }
}
